module.exports = __webpack_public_path__ + "img/logo_menu.6b934ef5.png";